import { server } from "helpers/config";

const SERVER_URL = server.apiHost;

export default {
  PTO_BULK_UPLOAD: `${SERVER_URL}/pto/policy/bulk-update-balance/`,
};
